import React from "react";
import { Link } from "react-router-dom";
import { Mail, Twitter, Github } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-neutral-200 bg-white" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="h-8 w-8 rounded-md bg-neutral-900 flex items-center justify-center text-white font-display font-bold">G</div>
            <span className="font-display font-semibold text-lg">GrantFlow</span>
          </div>
          <p className="text-sm text-neutral-600 max-w-xs mb-4">The end-to-end platform for winning US business and nonprofit grants — with AI-drafted documents and deadline autopilot.</p>
          <div className="flex items-center gap-3">
            <a href="mailto:support@grantflow.app" className="h-9 w-9 rounded-full border border-neutral-200 flex items-center justify-center hover:border-neutral-900" aria-label="Email"><Mail size={16} /></a>
            <a href="#" className="h-9 w-9 rounded-full border border-neutral-200 flex items-center justify-center hover:border-neutral-900" aria-label="Twitter"><Twitter size={16} /></a>
            <a href="#" className="h-9 w-9 rounded-full border border-neutral-200 flex items-center justify-center hover:border-neutral-900" aria-label="GitHub"><Github size={16} /></a>
          </div>
        </div>
        <div>
          <div className="overline mb-3">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:underline" to="/grants" data-testid="footer-grants">Grant discovery</Link></li>
            <li><Link className="hover:underline" to="/pricing" data-testid="footer-pricing">Pricing</Link></li>
            <li><Link className="hover:underline" to="/academy" data-testid="footer-academy">Academy</Link></li>
            <li><Link className="hover:underline" to="/faq" data-testid="footer-faq">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:underline" to="/about" data-testid="footer-about">About</Link></li>
            <li><Link className="hover:underline" to="/contact" data-testid="footer-contact">Contact</Link></li>
            <li><a className="hover:underline" href="mailto:hello@grantflow.app">Partnerships</a></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:underline" to="/terms" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link className="hover:underline" to="/privacy" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link className="hover:underline" to="/refund" data-testid="footer-refund">Refund policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-200 py-6 text-center text-xs text-neutral-500">
        © {new Date().getFullYear()} GrantFlow, Inc. · Made for founders and directors chasing capital · <a href="mailto:support@grantflow.app" className="hover:underline">support@grantflow.app</a>
      </div>
    </footer>
  );
}
